const commonModule = {
  confirm: "確定",
  cancel: "キャンセル",
  home: "ホーム",
  search: "検索",
  order: "購入チケット",
  coupon: "クーポン券",
  user: "マイページ",
  save: "保存",
  isDelete: "削除しますか?",
  isCancel: "キャンセルしますか?",
  addSuccess: "追加しました",
  cancelSuccess: "キャンセルしました",
  add: "追加",
  delete: "削除",
  submit: "コメントする",
  emailFormat: "正しいメールアドレスをご入力ください",
  example: "例",
  min: "分",
  noContent: "データが見つかりません",
  privateBrowse:"現在シークレットモードになっています。正常に使える為に、シークレットモードを閉じてください。",
  back: "元に戻す",
  detail: "詳細へ",
  store: "店舗",
  amount: "金額",
  loading: "Loading...",
  bn: "番号",
  goHome: "トップペ一ジへ",
  desc1:"販売中のチケット",
  agree:"に同意するプライバシーポリシー",
  card:"クレジットカードを選びます",
  point_list:"利用スポット",
  invoice:"内容をお願いします。",
  jpPhone:"日本 +81",
  cnPhone:"中国 +86",
  krPhone:"韓国 +82",
  hkPhone:"香港 +852",
  moPhone:"澳门 +853",
  twPhone:"台湾 +886",
  useNum:"使用枚数",
  useSuccess:"利用済",
  isUse:"利用しますか？",
  couponOrder:"注文番号",
  couponCount1:"利用可能クーポン券数",
  couponCount2:"利用済クーポン券数",
  couponCount3:"期限切れのクーポン券数",
  couponCount4:"獲得クーポン券数",
  couponTime:"獲得日時",
  couponShop:"店舗名",
  couponAddr:"住所",
  couponStatus1:"未使用",
  couponStatus2:"一部使用",
  couponStatus3:"使用済",
  couponStatus4:"期限切れです",
  close:"閉じる",
  comment: "レビュー",
  copy: "コピー",
  copySuccess: "コピー成功",
  copyFailed: "コピー失敗",
};

export default commonModule;
